/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Product Card Tariff Price component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.10.0
 */

import { formatBalanceWithoutTrailingZeros } from '../../../../../utils/formatText';
import { ProductCardTariffPriceStyled } from '../styled/ProductCardTariffStyled';

export interface IProductCardTariffPriceProps {
    subTitle?: string;
    unit: string;
    value: number;
}

const ProductCardTariffPrice = (props: IProductCardTariffPriceProps) => {
    return (
        <ProductCardTariffPriceStyled>
            <div className="product-card__price-title">
                {formatBalanceWithoutTrailingZeros(props.value)} {props.unit}
            </div>
            {
                props.subTitle && <div className="product-card__price-subtitle">
                    {props.subTitle}
                </div>
            }
        </ProductCardTariffPriceStyled>
    );
};

export default ProductCardTariffPrice;
